// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_kd-0";
export var animationContainer = "_kd-1";
export var itemPrice = "_kd-a";
export var itemizedContent = "_kd-9";
export var itemizedHeader = "_kd-7";
export var itemizedRow = "_kd-8";
export var itemizedSection = "_kd-6";
export var modalContent = "_kd-2";
export var orderName = "_kd-3";
export var refundOption = "_kd-4";
export var refundOptionsContainer = "_kd-5";
export var shippingLabel = "_kd-b";
export var totalRow = "_kd-c";